import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import styled from 'styled-components'

// To preserve new lines
export const FlowpageCaptionText = styled(Text)`
  white-space: pre-wrap;
`
